/**
 * 한국어 로케일 리소스 통합 export
 */

// UI 영역별 리소스
export { commonStr } from './common';
export { strategyStr } from './strategy';
export { marketStr } from './market';
export { menuBarStr } from './menu-bar';
export { settingStr } from './setting';
export { chartStr } from './chart';
export { triggerStr } from './trigger';
export { pageStr } from './page';

// 기존 리소스 (하위 호환성)
export { ErrorMessages, TriggerIgnoreReasonCaption } from './errors';
export { FormErrorMessages } from './form-errors';
export { CcxtErrorMessages, getCcxtErrorMessage } from './ccxt-errors';

// Enums 통합 객체
export { enums } from './enums';
